const BASE_URL = import.meta.env.VITE_API_URL || 'http://api-dev.sicamovil.mx/api'

function getToken() {
  return localStorage.getItem('auth_token')
}

async function request(method, path, body = null) {
  const token = getToken()
  const headers = {
    'Content-Type': 'application/json',
    ...(token ? { Authorization: token } : {}),
  }

  const opts = { method, headers }
  if (body !== null) opts.body = JSON.stringify(body)

  const res = await fetch(`${BASE_URL}${path}`, opts)

  if (res.status === 204) return null

  const data = await res.json().catch(() => null)

  if (!res.ok) {
    const msg = data?.errors
      ? (Array.isArray(data.errors) ? data.errors.join(', ') : String(data.errors))
      : `HTTP ${res.status}`

    // Session expired / not authenticated → notify the app to redirect to login
    if (res.status === 401 || msg === 'Usuario no autenticado') {
      window.dispatchEvent(new CustomEvent('sicamex:unauthenticated'))
    }

    throw new Error(msg)
  }

  return data
}

export const api = {
  get:   (path)        => request('GET',    path),
  post:  (path, body)  => request('POST',   path, body),
  put:   (path, body)  => request('PUT',    path, body),
  patch: (path, body)  => request('PATCH',  path, body),
  del:   (path)        => request('DELETE', path),
}
